<template>
  <GlobalAlertWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-descriptions direction="horizontal" :column="1">
      <el-descriptions-item label="门店名称">{{ form.name }}</el-descriptions-item>
      <el-descriptions-item label="真实姓名">{{ form.realname }}</el-descriptions-item>
      <el-descriptions-item label="性别">{{ form.sex==0?'男':form.sex==1?'女':'未知' }}</el-descriptions-item>
      <el-descriptions-item label="门店位置">{{ form.addr }}</el-descriptions-item>
      <el-descriptions-item label="联系方式">{{ form.phone }}</el-descriptions-item>
      <el-descriptions-item label="证件号码">{{ form.idcard }}</el-descriptions-item>
      <el-descriptions-item label="店铺简介">{{ form.info }}</el-descriptions-item>
      <el-descriptions-item label="LOGO图片">
        <el-image style="margin-right: 10px; width: 160px; height: 90px; border-radius: 2px;" :src="form.imgurl" :preview-src-list="[form.imgurl]"></el-image>
      </el-descriptions-item>
      
      <el-descriptions-item label="门头图片">
        <el-image
          v-for="item in form.fileList"
          style="margin-right: 10px; width: 160px; height: 90px; border-radius: 2px;"
          :key="item.id"
          :src="item.fileurl"
          :initial-index="index"
          :preview-src-list="form.fileList.map(item => item.fielUrl)"
        ></el-image>
      </el-descriptions-item>
      <el-descriptions-item label="证件信息">
        <el-image style="margin-right: 10px; width: 160px; height: 90px; border-radius: 2px;" :src="form.businessImg" :initial-index="0" :preview-src-list="[form.businessImg, form.idcardImg, form.idcardImgBack]"></el-image>
        <el-image style="margin-right: 10px; width: 160px; height: 90px; border-radius: 2px;" :src="form.idcardImg" :initial-index="1" :preview-src-list="[form.businessImg, form.idcardImg, form.idcardImgBack]"></el-image>
        <el-image style="width: 160px; height: 90px; border-radius: 2px;" :src="form.idcardImgBack" :initial-index="2" :preview-src-list="[form.businessImg, form.idcardImg, form.idcardImgBack]"></el-image>
      </el-descriptions-item>
    </el-descriptions>
    <div slot="footer"></div>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
export default {
  name: 'OperaCouponWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow },
  data () {
    
    return {
      getDate: [],
      // 表单数据
      form: {
        id: null,
        name: '',
        realname: '',
        sex: '',
        birthday: '',
        addr: '',
        phone: '',
        idcard: '',
        email: '',
        info: '',
        idcardImg: '',
        idcardImgBack: '',
        applyPlatList: '',
        fileList: []
      },
      
    }
  },
  created () {
    this.config({
      api: '/business/coupon',
      'field.id': 'id'
    })
  },
  methods: {
    
  },
}
</script>

<style lang="scss" scoped>
</style>

